import * as Sentry from '@sentry/react';

Sentry.init({
    dsn: 'https://d5c48438d40339896ed3f3bd4cc525a3@o4505585101701120.ingest.us.sentry.io/4511110559432704',
    enabled: import.meta.env.MODE !== 'development',
    environment: import.meta.env.MODE,
    release: `account@${__VERSION__}`,
    beforeSend: (event) => {
        for (const exception of event?.exception?.values || []) {
            for (const frame of exception?.stacktrace?.frames || []) {
                // 忽略来自扩展的错误
                if (frame?.filename?.includes('chrome-extension://') || frame?.filename?.includes('moz-extension://')) {
                    return null;
                }
            }
        }

        return event;
    },
});
